export enum Role {
  BalanceSupplierReader = 'DEX_BS_READER',
  DgoReader = 'DEX_DGO_READER',
  AtriasReader = 'DEX_ATR_READER',
  AtriasContributor = 'DEX_ATR_CONTRIBUTOR',
}
